"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedLanguages = void 0;
const lodash_map_1 = __importDefault(require("lodash.map"));
const languages = [
    {
        name: 'Bulgarian',
        code: 'BG',
    },
    {
        name: 'Croatian',
        code: 'HR',
    },
    {
        name: 'Czech',
        code: 'CS',
    },
    {
        name: 'Danish',
        code: 'DA',
    },
    {
        name: 'Dutch',
        code: 'NL',
    },
    {
        name: 'English',
        code: 'EN',
    },
    {
        name: 'Estonian',
        code: 'ET',
    },
    {
        name: 'Finnish',
        code: 'FI',
    },
    {
        name: 'French',
        code: 'FR',
    },
    {
        name: 'German',
        code: 'DE',
    },
    {
        name: 'Greek',
        code: 'EL',
    },
    {
        name: 'Hungarian',
        code: 'HU',
    },
    {
        name: 'Irish',
        code: 'GA',
    },
    {
        name: 'Italian',
        code: 'IT',
    },
    {
        name: 'Latvian',
        code: 'LV',
    },
    {
        name: 'Lithuanian',
        code: 'LT',
    },
    {
        name: 'Maltese',
        code: 'MT',
    },
    {
        name: 'Polish',
        code: 'PL',
    },
    {
        name: 'Portuguese',
        code: 'PT',
    },
    {
        name: 'Romanian',
        code: 'RO',
    },
    {
        name: 'Slovak',
        code: 'SK',
    },
    {
        name: 'Slovene',
        code: 'SL',
    },
    {
        name: 'Spanish',
        code: 'ES',
    },
    {
        name: 'Swedish',
        code: 'SV',
    },
];
function getSupportedLanguages() {
    return (0, lodash_map_1.default)(languages, language => {
        return language.code.toLowerCase();
    });
}
exports.getSupportedLanguages = getSupportedLanguages;
//# sourceMappingURL=data:application/json;base64,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